import {ChangePasswordModal, SecurityCard} from "@housebets/housebets-x-package";
import React from "react";
import {useGTMEvents} from "app/hooks/useGTMEvents";
import {useChangePasswordData} from "./hooks/useChangePasswordData";
import {ChangePasswordForm} from "../../../forms";
import {useIntl} from "react-intl";

export const ChangePassword: React.FC = () => {
    const {isChangePasswordOpen, setIsChangePasswordOpen} = useChangePasswordData();
    const {modal} = useGTMEvents();
    const {$t} = useIntl();

    return (
        <>
            <SecurityCard
                title={$t({id: "ChangePassword"})}
                text={
                    // <div
                    //     dangerouslySetInnerHTML={{
                    //         __html: 'Last change - <span>Aug 16 2024</span>',
                    //     }}
                    // />
                    <></>
                }
                onClick={() => {
                    setIsChangePasswordOpen(true);
                }}
                submitButtonText={$t({id: "ChangePassword.button"})}
                verifiedButtonText={$t({id: "ChangePassword.button"})}
            />

            <ChangePasswordModal
                isOpen={isChangePasswordOpen}
                onClose={() => setIsChangePasswordOpen(false)}
                afterOpenModal={() => {
                    modal.show("change_password");
                }}
                onAfterClose={() => {
                    modal.close("change_password");
                }}>
                <ChangePasswordForm
                    onSubmit={() => {
                        setIsChangePasswordOpen(false);
                    }}
                />
            </ChangePasswordModal>
        </>
    );
};

ChangePassword.displayName = "ChangePassword";
